import { render, staticRenderFns } from "./ReinsPrint.vue?vue&type=template&id=f618ab54&scoped=true&"
import script from "./ReinsPrint.vue?vue&type=script&lang=js&"
export * from "./ReinsPrint.vue?vue&type=script&lang=js&"
import style0 from "./ReinsPrint.vue?vue&type=style&index=0&id=f618ab54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f618ab54",
  null
  
)

export default component.exports